<template>
  <div class="ds-control dsf_teas_assess mobile dsf_teas_learning">
    <van-tabs v-if="!error" v-model="activeIndex">
      <van-tab v-for="(it, index) in tabs" :key="it.kc_text" :title="it.kc_text" :name="index">
        <div class="scroll-box">
          <IframePage :url="detailUrl" :classId="it.teas_jwgl_bjgl_id" :pkglId="it.teas_jwgl_pkgl_id"></IframePage>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import IframePage from './iframePage'

export default dsf.component({
  name: "DsfMobileTeasAssess",
  ctrlCaption: "评估",
  mixins: [$mixins.control],
  design: {
    isMask: false
  },
  props: {
    // 接口地址
    sourcesUrl: {
      type: String,
      default: ":/dsfa/dsfa/mobile/platform/appraise/queryStuCourseAppraiseList",
    },
    // 跳转接口地址
    detailUrl: {
      type: String,
      default: ":/dsfa/dsfa/mobile/platform/appraise/geCourseAppraiseUrl",
    },
  },
  data() {
    return {
      activeIndex: 0,
      tabs: [],
      error: false
    };
  },

  computed: {
  },

  components: {
    IframePage
  },

  watch: {
    
  },

  mounted() {
    if (this.isDesign) {
      this.$dispatch("design-height-change", '100%');
      this.tabs = [{
        kc_text: '课程评估',
        teas_jwgl_pkgl_id: dsf.uuid(4)
      },{
        kc_text: '教学管理评估',
        teas_jwgl_pkgl_id: dsf.uuid(4)
      },{
        kc_text: '后勤服务评估',
        teas_jwgl_pkgl_id: dsf.uuid(4)
      }]
    } else {
      this.getData()
    }
  },

  created() {
  },

  methods: {
    getData() {
      const loading = dsf.layer.loading();
      this.$http
        .get(this.sourcesUrl, {
          pageNo: 1,
          pageSize: 999
        })
        .done((res) => {
          if (res.success && res.state == 20000 && res.data) {
            this.tabs = res.data
          } else {
            dsf.layer.message(res.message, false);
            this.error = true;
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
          this.error = true;
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
  }
});
</script>
